import axios from "axios";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import { useParams } from "react-router-dom";

import faildtransaction from "../../../assets/images/faildtransaction.svg";
import successfultransaction from "../../../assets/images/successfultransaction.svg";
import { api } from "../../../utils/axios/Config";
import { convertTrackingCodesToString, handleErrorApi } from "../../../utils/utils";
import Loader from "../../shared/Loader";
import ReactShowMoreText from "../../shared/show-more";

const Row = ({ label, value }) =>
  value ? (
    <div className="w-full flex gap-2">
      <p className="bg-[#f5f5f5] w-1/3 px-2 py-2 rounded-v-md flex justify-center items-center">{label}</p>
      <p className="bg-[#f5f5f5] w-2/3 flex rounded-v-md justify-center items-center">{value}</p>
    </div>
  ) : null;

const TransactionTextArea = ({ label, value }) => (
  <div className="w-full flex gap-2">
    <p className="bg-neutral-00 w-1/3 px-2 py-2 rounded-v-md flex justify-center items-center h-fit">
      {label}
    </p>
    <ReactShowMoreText
      lines={3}
      more="نمایش بیشتر"
      less="نمایش کمتر"
      className="bg-neutral-00 w-2/3 flex rounded-v-md justify-center items-center p-1"
      anchorClass="text-dark cursor-pointer text-[10px]"
      expanded={false}
      truncatedEndingComponent={"... "}
    >
      {value || ""}
    </ReactShowMoreText>
  </div>
);

const Transactions = () => {
  const { tracking_code } = useParams();
  const [loading, setLoading] = useState(true);
  const [transactionData, setTransactionData] = useState(null);
  const [recipeLoading, setRecipeLoading] = useState(false);

  useEffect(() => {
    let timer = setTimeout(() => {
      axios
        .post(
          `${import.meta.env.VITE_PAYMENT_DATABASE_ENDPOINT}/transactions/v2/verify/`,
          {
            vanda_tracking_code: tracking_code,
          },
          {
            responseType: "text",
          },
        )
        .then((res) => {
          const result = convertTrackingCodesToString(res);
          setTransactionData(result);
        })
        .finally(() => setLoading(false));
    }, 300);
    return () => clearTimeout(timer);
  }, [tracking_code]);

  const handleBack = () =>
    (window.location.href = `${import.meta.env.VITE_FORM_URL}/f/${transactionData?.form_link}`);

  const getRecipe = async () => {
    if (!tracking_code || recipeLoading) return;

    try {
      setRecipeLoading(true);

      const { data } = await api.post(
        `/generals/form/recipe/jpeg/`,
        { vanda_tracking_code: tracking_code },
        {
          headers: {
            token: Cookies.get("token"),
            token_type: "bearer",
          },
        },
      );

      if (data?.url) {
        window.location.href = import.meta.env.VITE_STORAGE_ENDPOINT + data.preview_url;
      } else {
        console.error("Recipe URL not returned");
      }
    } catch (error) {
      handleErrorApi(error);
    } finally {
      setRecipeLoading(false);
    }
  };

  if (loading)
    return (
      <div className="w-full h-screen flex justify-center items-center bg-primary-50">
        <div className="w-[720px] flex flex-col gap-2 bg-neutral-10 p-9 rounded-v-4xl">
          {Array(6)
            .fill(0)
            .map((_, i) => (
              <div key={i} className="w-full flex gap-2">
                <p className="bg-white  w-1/3 h-10 rounded-v-md "></p>
                <p className="bg-white  w-2/3 h-10 "></p>
              </div>
            ))}
        </div>
      </div>
    );

  const trx = transactionData?.transaction || {};
  const isSuccess = trx.transaction_state === "success";

  return (
    <div className="w-full h-screen flex justify-center items-center bg-primary-50 py-3">
      <div className="w-[720px] max-h-[90vh] flex flex-col gap-2 overflow-scroll no-scrollbar p-9 rounded-v-4xl bg-neutral-00">
        <img
          className="rounded-v-4xl"
          src={isSuccess ? successfultransaction : faildtransaction}
          alt={isSuccess ? "success" : "failed"}
        />
        <p
          className={`p-6 text-title-2xl-semibold text-center w-full ${
            isSuccess ? "text-success-60" : "text-error-90"
          }`}
        >
          {isSuccess ? "پرداخت شما با موفقیت انجام شد!" : "پرداخت ناموفق!"}
        </p>

        <Row label="نام دریافت کننده" value={transactionData?.acceptor_name} />
        <Row label="نام پرداخت کننده" value={trx.payer_name} />
        <Row label="مبلغ پرداخت (تومان)" value={trx.amount && (trx.amount / 10).toLocaleString()} />
        <Row
          label="تاریخ تراکنش"
          value={
            trx.invoice_time &&
            new DateObject({
              date: trx.invoice_time * 1000,
              calendar: persian,
            }).format("YYYY/MM/DD")
          }
        />
        <Row label="موبایل" value={trx.payer_mobile} />
        <Row label="ایمیل" value={trx.payer_mail} />
        <Row label="کد رهگیری" value={trx.vanda_tracking_code} />
        <Row label="کد پستی" value={trx.payer_postal_code} />
        <Row label="کد ملی" value={trx.payer_national_code} />
        <Row label="آدرس" value={trx.payer_address} />
        <Row label="کد سفارش" value={trx.order_number} />
        {trx.payer_description && <TransactionTextArea label="توضیحات" value={trx.payer_description} />}

        <div className="w-full mt-5 flex gap-2">
          <button
            className="bg-white border-2 border-dark text-dark rounded-md px-4 py-2 flex-1"
            onClick={handleBack}
          >
            بازگشت
          </button>
          <button
            className="bg-dark text-white rounded-md px-4 py-2 flex-1 flex justify-center gap-2 disabled:bg-slate-300"
            onClick={getRecipe}
            disabled={recipeLoading}
          >
            {recipeLoading && (
              <div className="flex gap-4 items-center">
                <div className="flex-center gap-2 w-6 h-full ">
                  <Loader />
                </div>
              </div>
            )}
            دریافت رسید
          </button>
        </div>
      </div>
    </div>
  );
};

export default Transactions;
